export default "__VITE_ASSET__CdG46X70__"